import { useEffect } from 'react';

import { useSubscriptionsDispatchContext } from '../SubscriptionsContextProvider';

export const useSubscriptionEvent = ({
	onDataReceived,
	skip = false,
	contentId,
	contentType,
	delta,
	subscriberId,
}: {
	onDataReceived: ((value: any) => void) | (() => void);
	skip?: boolean;
	contentId?: string | null;
	contentType?: string | null;
	delta: string;
	subscriberId: string;
}) => {
	const dispatch = useSubscriptionsDispatchContext();

	const { setContentId, setContentType, removeSubscriber, addSubscriber } = dispatch || {};

	useEffect(() => {
		if (skip || !dispatch || !contentId || !contentType) {
			return;
		}
		setContentId?.(contentId);
		setContentType?.(contentType);
		addSubscriber?.({ delta, subscriberId, onSubscriptionData: onDataReceived });
		return () => {
			removeSubscriber?.({ delta, subscriberId });
		};
	}, [
		skip,
		dispatch,
		contentId,
		contentType,
		setContentId,
		setContentType,
		addSubscriber,
		removeSubscriber,
		subscriberId,
		delta,
		onDataReceived,
	]);

	return null;
};
